import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

function FloatingQuoteCTA({ triggerRef, onClick, visible = true }) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!visible) {
            setShow(false);
            return;
        }
        const delay = setTimeout(() => setShow(true), 600);
        return () => clearTimeout(delay);
    }, [visible]);

    useEffect(() => {
        if (!visible) return;
        const el = triggerRef?.current;
        if (!el) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
                    setShow(true);
                }
            },
            { threshold: 0.1 }
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, [triggerRef, visible]);

    return (
        <AnimatePresence>
            {show && visible && (
                <motion.div
                    className="FloatingQuoteCTA"
                    initial={{ y: 120, opacity: 0, scale: 0.9 }}
                    animate={{ y: 0, opacity: 1, scale: 1 }}
                    exit={{ y: 120, opacity: 0, scale: 0.9 }}
                    transition={{ type: 'spring', stiffness: 380, damping: 28 }}
                >
                    <button className="FloatingCTA-button" onClick={onClick}>
                        <span className="FloatingCTA-pulse" />
                        <span className="FloatingCTA-icon">✓</span>
                        <span className="FloatingCTA-label">Quiero esta cotización</span>
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export { FloatingQuoteCTA };
